module.exports = __webpack_public_path__ + "img/navbar-4.e89934c5.png";